import {request,GETApi,POSTApi} from '../utils/request'
export const licenseReducer =  request({reducerPath:'license',endpoints:(builder)=>{
    return {
      commercial: POSTApi(builder,'/weblicense/commercial'),//商业客户WebLicense申请
      experiment: POSTApi(builder,'/weblicense/experiment'),//客户试用 WebLicense申请
      licenseList:GETApi(builder,'/weblicense/page'),//分页查询客户WebLicense信息
      licenseSelectList:GETApi(builder,'/weblicense/webLicenseId/list'),//查询当前用户的所欲WebLicense列表
      renew:GETApi(builder,'/weblicense/experiment/renew'),//续约申请
      updateNickname:POSTApi(builder,'/weblicense/update/nickname'),//修改nickname
      changeWebLicense:POSTApi(builder,'/weblicense/changeWebLicense'),//商业用户申诉修改WebLicense
    }
}})
export const { useCommercialMutation,useExperimentMutation,useLazyLicenseListQuery,useLazyLicenseSelectListQuery,useLazyRenewQuery,useUpdateNicknameMutation,useChangeWebLicenseMutation } = licenseReducer